import { render, staticRenderFns } from "./ResolvePatientTrackingIssuesView.vue?vue&type=template&id=f786f518"
import script from "./ResolvePatientTrackingIssuesView.vue?vue&type=script&lang=js"
export * from "./ResolvePatientTrackingIssuesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports